export default "__VITE_ASSET__CWYU_BU5__"